import { render, staticRenderFns } from "./detailEleveTeacher.vue?vue&type=template&id=6b004611&"
import script from "./detailEleveTeacher.vue?vue&type=script&lang=js&"
export * from "./detailEleveTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports